export default {
  documentTemplateFields: [],
  documentTemplateField: undefined,
};
